import Vue from 'vue';
import App from './App.vue';
import Confirmation from './Confirmation.vue';
import Vuelidate from 'vuelidate';
import VModal from 'vue-js-modal';

Vue.use(Vuelidate);
Vue.use(VModal, { componentName: 'VModal' });

const bookingPath = document.querySelector('#online-booking');
const confirmationPage = document.querySelector('#online-booking-confirmation');

const params = new URLSearchParams(window.location.search);
const uid = params.get('id');

if (bookingPath) {
    new Vue({
        el: bookingPath,
        render: (h) => h(App)
    });
} else if (confirmationPage) {
    new Vue({
        el: confirmationPage,
        render: (h) => {
            return h(Confirmation, {
                props: { uid }
            });
        }
    });
}
